import { Empty, Select, Tooltip } from 'antd'
import { HiOutlineMail } from 'react-icons/hi'
import AntdAvatar from 'components/Avatar'
import Button from 'components/Button'
import Flex from 'components/Flex'
import NoInterview from 'components/icons/NoInterview.png'
import Pagination from 'components/Pagination'
import React, { Fragment, useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import MultiFilter from '../../../../components/UIComponents/MultiFilter.js'
import PlacementHistoryWithResume from '../../../../components/UIComponents/PlacementHistoryWithResume/index.js'
import TableSearchFilter from '../../../../components/UIComponents/TableSearchFilter'
import { BoldText } from '../../../JobRoles/PageHeader/style'
import { MultiPadding, TableEllipse } from '../../../Placement/style'
import { SelectAllFlex, StyledTabFilter } from '../../style'
import '../../style.css'
import DegreeDepartmentFilter from '../EvaluationProcessFilter/Partials/DegreeDepartmentFilter'
import StatusFilter from '../EvaluationProcessFilter/Partials/StatusFilter.js'
import GenderFilter from '../EvaluationProcessFilter/Partials/GenderFilter'
import SkillsFilter from '../EvaluationProcessFilter/Partials/SkillsFilter'
import YearFilter from '../EvaluationProcessFilter/Partials/YearFilter'
import ScoreFilter from '../EvaluationProcessFilter/Partials/ScoreFilter'
import ArrearsFilter from '../EvaluationProcessFilter/Partials/ArrearsFilter'
import LocationFilter from '../EvaluationProcessFilter/Partials/LocationFilter'
import DriveStatus from './DriveStatus'
import OfferTableStatusIcon from './OfferTableStatusIcon'
import {
  sendInAppNotification,
  sendNotificationBulkEmailWhatsapp,
  sendNotificationBulkEmail,
} from 'modules/Students/actions'
import ReactDOMServer from 'react-dom/server'
import ShortlistedTemplate from 'components/EmailTemplate/ShortlistedTemplate'
import RejectedTemplate from 'components/EmailTemplate/RejectedTemplate'
import IntentToOfferTemplate from 'components/EmailTemplate/IntentToOfferTemplate'
import AbsentTemplate from 'components/EmailTemplate/AbsentTemplate'
import MoveToNextRoundTemplate from 'components/EmailTemplate/MoveToNextRoundTemplate'
import RejectIcon from 'components/icons/DriveTableIcon/Reject'
import ShortlistIcon from 'components/icons/DriveTableIcon/MovedToNextRoundTool'
import { EmptyDivElement } from '../../../../components/UIComponents/CommonStyledComponent'
import { IconContainer, IconText } from '../../style'

import {
  EmptyWrapper,
  MenuFlex,
  RowNumberData,
  SelectStatusFlex,
  SpanDescription,
  SubmitFlex,
  OptOutText,
  StyledDivider,
} from './Style'
import TableStatusIcon from './TableStatusIcon'
import { StyledTableSqare } from './TableStyle'
import ResumeDownload from '../../../../components/icons/DriveTableIcon/ResumeDownload.js'

export const centerText = styled(Flex)`
  align-content: center;
`

const StyledSelect = styled(Select)`
  .ant-select-selector {
    width: 7em !important;
    height: 2.6em !important;
    justify-content: center !important;
    align-items: center !important;
    border-color: blue !important;
    border-radius: 5px !important;
    .ant-select-selection-item {
      font-weight: bold;
    }
  }
`

const DataTextContainar = styled.div``
const SimpleStatusIcon = ({
  status,
  onChange,
  candidateStatus,
  selectedCandidateId,
  jobRolePreviewData,
  rolesMetrics,
}) => {
  const statusDisabled =
    jobRolePreviewData?.jobRoleInstituteMap?.[0]?.roleStatus ===
      'ROLE_CLOSED' ||
    jobRolePreviewData?.jobRoleInstituteMap?.[0]?.roleStatus === 'COMPLETED' ||
    !Array.isArray(rolesMetrics?.rounds) ||
    rolesMetrics.rounds.length === 0

  const isDisabled = statusDisabled || selectedCandidateId?.length === 0
  return (
    <IconContainer>
      <IconText>Select status</IconText>

      <EmptyDivElement
        onClick={() => {
          if (!isDisabled) onChange('ACTIVE')
        }}
        style={{
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          opacity: isDisabled ? 0.5 : 1,
        }}
      >
        <ShortlistIcon paddingTop={'5px'} />
      </EmptyDivElement>

      {/* Reject Icon */}
      <EmptyDivElement
        onClick={() => {
          if (!isDisabled) onChange('REJECTED')
        }}
        style={{
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          opacity: isDisabled ? 0.5 : 1,
        }}
      >
        <RejectIcon />
      </EmptyDivElement>
      <StyledDivider type="vertical" />
      <EmptyDivElement
        onClick={() => {
          if (selectedCandidateId?.length > 0) onChange('Resume')
        }}
        style={{
          cursor: selectedCandidateId?.length === 0 ? 'not-allowed' : 'pointer',
          opacity: selectedCandidateId?.length === 0 ? '0.5' : '',
        }}
      >
        <ResumeDownload />
      </EmptyDivElement>
    </IconContainer>
  )
}

const IndividualDriveTable = ({
  setScheduleDrawer,
  candidateDeatils,
  setSortBy,
  rolesMetrics,
  state,
  setSelectedCandidateId,
  setSelectedCandidate,
  selectedCandidate,
  roleId,
  selectedRoundType,
  status,
  stage,
  selectedCandidateId,
  stages,
  updateCandidateRoleStatus,
  panelValue,
  setPanelValue,
  setPanelData,
  panelData,
  candidates,
  onPageChange,
  instituteCampusId,
  setUpdateStatus,
  load,
  handleResolveConflict,
  conflictData,
  stageIndex,
  menuOption,
  handleStatusChange,
  checkStatus,
  multiSelect,
  handleMultiFilter,
  handleFilter,
  handleFilterSearch,
  searchBy,
  handleDegreeChange,
  handleDepartmentChange,
  handleSpecialisationChange,
  selectAll,
  setSelectAll,
  currentPage,
  publishedBy,
  getPreview,
  getPlacementHistoryList,
  getJobRolePreview,
  getStudentPlacedList,
  wholeSelect,
  setWholeSelect,
  setDummyOpen,
  fetchCandidateList,
  currentTab,
  handleDegreeSearch,
  handleDepartSearch,
  jobRolePreviewData,
  handleGenderChange,
  handleSkillsChange,
  handleYearChange,
  handleScoreChange,
  handleArrearsChange,
  handleLocationChange,
  checkGender,
  checkSkills,
  checkYear,
  checkScore,
  checkArrears,
  checkLocation,
  skillsFilter,
  locationFilter,
  setBulkDownload,
  setPopup,
  handleSpecializationChange,
  handleSpecializationSearch,
  yearFilter,
  genderFilter,
  scoreEntries,
  setScoreEntries,
}) => {
  // Add scoreFilterRef
  const scoreFilterRef = useRef(null)

  const dispatch = useDispatch()
  const institute = useSelector(state => state.auth.instituteDetails)
  const userData = useSelector(state => state.auth.userData)
  const userRole = useSelector(state => state.auth.userRoleList)

  const getRoleName = id => {
    let roleName = userRole?.filter(data => data?.id === id)[0]?.name
    return roleName ?? 'Admin'
  }

  const getUserRoleName = () => {
    return getRoleName(
      userData?.pluginlive_id
        ? userData?.admin?.instRoleId
        : userData?.admin_role_id ?? userData?.role_id
    )
  }

  const [expand, setExpand] = useState(true)
  const [studentId, setStudentId] = useState(null)
  const [isOpenHistory, setIsOpenHistory] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [enableSelectAll, setEnableSelectAll] = useState(false)
  const params = useParams()

  const onSorting = (pagination, filter, sorter) => {
    setSortBy(sorter)
    fetchCandidateList(params?.roleId, currentPage, sorter)
  }

  const handleNameClick = async data => {
    try {
      let studentId =
        publishedBy == 'INSTITUTE' ? data?.studentId : data?.student?.id
      setIsOpenHistory(true)
      setStudentId(studentId)
    } catch (error) {
      console.error(error)
    } finally {
      //
    }
  }

  const collapseExtend = candidateDeatils?.topics?.find(item => item?.subTopic)


  const columns = [
    {
      width: 120,
      title: <div style={{ width: '90%' }}>Status</div>,
      dataIndex: 'status',
      key: 'status',

      hidden: publishedBy !== 'INSTITUTE',
      fixed: 'left',

      render: (status, record, index) => {
        return (
          <div>
            <div>
              {record?.student?.currentCourse?.optOutStatus === 1 ||
              record?.student?.currentCourse?.optOutStatus === 4 ? (
                <>
                  <Tooltip title={'Opted-out'}>
                    <OptOutText>Opted-out</OptOutText>
                  </Tooltip>
                </>
              ) : (
                <DriveStatus
                  status={
                    stage == 'all_candidates'
                      ? record.status
                      : rolesMetrics?.rounds[parseInt(stageIndex)]?.name !==
                        record.stage
                      ? 'SHORTLISTED'
                      : record.status
                  }
                  offerStatus={record?.offerStatus}
                />
              )}
            </div>
          </div>
        )
      },
    },
    {
      width: 120,
      title: <div style={{ width: '90%' }}>Status</div>,
      dataIndex: 'status',
      key: 'status',
      hidden: publishedBy !== 'CORPORATE',
      fixed: 'left',
      render: (_, data, index) => {
        return (
          <div>
            <div>
              <DriveStatus
                status={(stage === 'offer' || (stage === 'all_candidates' && data?.stage === 'offer')) ? 'SELECTED' : data?.corporateStatus}
                offerStatus={data?.offerStatus}
              />
            </div>
          </div>
        )
      },
    },

    {
      width: 150,
      title: 'Name',
      dataIndex: 'firstName',
      fixed: 'left',
      key: 'firstName',
      render: (_, candidateData) => {
        let name =
          candidateData?.student?.firstName +
          ' ' +
          candidateData?.student?.lastName

        return (
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <div style={{ display: 'flex', gap: '10px', flex: 1, minWidth: 0 }}>
              <div
                style={{
                  width: '35px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <AntdAvatar
                  style={{
                    verticalAlign: 'middle',
                  }}
                  src={candidateData?.student?.profileUrl}
                  IconName={candidateData?.student?.firstName?.split('')[0]}
                ></AntdAvatar>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <Tooltip title={`${name}`}>
                  <TableEllipse
                    onClick={() => handleNameClick(candidateData)}
                    style={{
                      color: 'rgba(50, 73, 215, 1)',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                    }}
                  >
                    {name}
                  </TableEllipse>
                  <p style={{ color: '#bfbfbf', margin: '0px' }}>
                    {candidateData?.student?.uniRollNo ?? '-'}
                  </p>
                </Tooltip>
              </div>
            </div>
            {candidateData?.isEmail && (
              <Tooltip title="Email sent">
                <HiOutlineMail 
                  style={{ 
                    color: '#bfbfbf', 
                    fontSize: '22px',
                    marginLeft: '8px',
                    flexShrink: 0
                  }} 
                />
              </Tooltip>
            )}
          </div>
        )
      },
    },

    {
      width: 180,
      title: 'Contact details ',
      dataIndex: 'instituteCampusName',
      key: 'instituteCampusName',
      render: (_, { student }) => (
        <div>
          <div>{student?.studentPersonalProfile?.phoneNumber ?? '-'}</div>
          <Tooltip title={`${student?.studentPersonalProfile?.primaryEmail}`}>
            <TableEllipse>
              {student?.studentPersonalProfile?.primaryEmail}
            </TableEllipse>
          </Tooltip>
        </div>
      ),
    },

    {
      width: 180,
      title: 'Degree & Department',
      dataIndex: 'Degree & Department',
      key: 'Degree & Department',
      render: (_, { student }) => (
        <RowNumberData>
          <DataTextContainar
            style={{
              width: 'max-content',
            }}
          >
            <Tooltip
              title={
                <div>
                  {student?.currentCourse?.degree} <br />
                  {student?.currentCourse?.department}
                </div>
              }
            >
              <div
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textTransform: 'initial',
                }}
              >
                {student?.currentCourse?.degree}
                <br />
                {student?.currentCourse?.department}
              </div>
            </Tooltip>
          </DataTextContainar>
        </RowNumberData>
      ),
    },

    {
      title: 'Current Round',
      dataIndex: 'stage',
      sorter: true,
      key: 'stage',
      width: 100,
      hidden: stage !== 'all_candidates' || publishedBy !== 'INSTITUTE',
      sortDirections: ['ascend', 'descend'],
      render: stage => (
        <RowNumberData>
          {stages === 'offer'
            ? 'Intent to offer'
            : stage?.length > 18
            ? `${stage?.substr(0, 18)}...`
            : stage}
        </RowNumberData>
      ),
    },

    {
      title: 'Current Round',
      dataIndex: 'stage',
      key: 'stage',
      width: 100,
      hidden: stage !== 'all_candidates' || publishedBy !== 'CORPORATE',
      render: (_, data) => (
        <RowNumberData>
          {data?.stage === 'offer'
            ? 'Intent to offer'
            : data?.stage?.length > 18
            ? `${data?.stage?.substr(0, 18)}...`
            : data?.stage}
        </RowNumberData>
      ),
    },
  ].filter(item => !item.hidden)

  let checkData
  const onData = (selectedRowKeys, selectedRows) => {
    setSelectedCandidateId(selectedRowKeys)
    setSelectedCandidate(selectedRows)
    setSelectAll(false)
    if (candidates?.totalPage > 1 && checkData === undefined) {
      setWholeSelect(false)
    }
  }

  const rowSelection = {
    selectedRowKeys: selectedCandidateId,
    onChange: (selectedRowKeys, selectedRows) => {
      onData(selectedRowKeys, selectedRows)
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      setWholeSelect(selected)
      checkData = selectedRows.length
    },
    preserveSelectedRowKeys: true,
    getCheckboxProps: record => {
      let isScheduled = ''
      stageIndex = stageIndex ?? 0

      const isOptedOut =
        record?.student?.currentCourse?.optOutStatus === 1 ||
        record?.student?.currentCourse?.optOutStatus === 4
      
      if (rolesMetrics?.rounds?.length > 0) {
        if (
          !isOptedOut &&
          (record.stage === null ||
            (record.stage === undefined && stage === 'all_candidates'))
        ) {
          isScheduled = true
        } else {
          if (stage === 'all_candidates') {
            isScheduled =
              !isOptedOut &&
              (record.status === undefined ||
                record.status === 'ACTIVE' ||
                record.status === 'SELECTED' ||
                record.status === 'SKIPPED')
          } else {
            isScheduled =
              !isOptedOut &&
              ((rolesMetrics?.rounds[parseInt(stageIndex) + 1]?.name ==
                record.stage &&
                (record.status === 'ACTIVE' || record.status === 'SELECTED' || record.status === undefined) &&
                record.offerStatus === 'NOT_RELEASED') ||
                (rolesMetrics?.rounds[parseInt(stageIndex)]?.name ==
                  record.stage &&
                  (record.status === 'ACTIVE' ||
                    record.status === 'SELECTED' ||
                    record.status == 'ABSENT' ||
                    record.status == 'REJECTED' ||
                    record.status == 'SKIPPED' ||
                    record.status === undefined) &&
                  record.offerStatus === 'NOT_RELEASED') ||
                rolesMetrics?.rounds[parseInt(stageIndex)]?.name === 'offer')
          }
        }
      } else {
        isScheduled = true
      }
      return {
        disabled: !isScheduled,
      }
    },
  }
  useEffect(() => {
    let anyRecordScheduled = false
    candidates &&
      candidates?.result !== 0 &&
      candidates?.result?.forEach(record => {
        if (stageIndex) {
          const isScheduled =
            (rolesMetrics?.rounds[parseInt(stageIndex) + 1]?.name ==
              record.stage &&
              (record.status === 'ACTIVE' || record.status === 'SELECTED' || record.status === undefined) &&
              record.offerStatus === 'NOT_RELEASED') ||
            (rolesMetrics?.rounds[parseInt(stageIndex)]?.name == record.stage &&
              (record.status === 'ACTIVE' ||
                record.status === 'SELECTED' ||
                record.status == 'REJECTED' ||
                record.status == 'SKIPPED' ||
                record.status === undefined) &&
              record.offerStatus === 'NOT_RELEASED') ||
            rolesMetrics?.rounds[parseInt(stageIndex)]?.name == 'offer'
          if (isScheduled) {
            anyRecordScheduled = true
          }
        }
      })
    setEnableSelectAll(anyRecordScheduled)
  }, [candidates])

  const onChangeStatus = async data => {
    if (data === 'Resume') {
      return handleDownload()
    }
    let payLoad = {
      studentId: rowSelection.selectedRowKeys,
      roundId: rolesMetrics?.rounds[stageIndex]?.id,
      forAllCandidate: !!selectAll,
      ...(rolesMetrics?.rounds?.length &&
      rolesMetrics.rounds[rolesMetrics.rounds.length - 1].name === stage
        ? { offerStatus: data, status: 'SELECTED' }
        : { status: data }),
      stage: stage === 'all_candidates' ? 'All candidate' : stage,
    }
    if (selectAll) {
      payLoad.studentId =
        (Array.isArray(candidates?.allStudents) && candidates.allStudents.length > 0
          ? candidates.allStudents
          : selectedCandidateId) || []
    }
    if (stage === 'all_candidates') {
      delete payLoad.roundId
    }
    const result = await updateCandidateRoleStatus(
      payLoad,
      instituteCampusId,
      roleId
    )

    if (result?.status >= 200) {
      setSelectedCandidateId([])
      setSelectedCandidate([])
      setSelectAll(false)
      setWholeSelect(false)
      setUpdateStatus(result)
    } else {
      setUpdateStatus(result)
    }

    // Check if status is SHORTLISTED and not a last round
    if (
      payLoad.status === 'SHORTLISTED' &&
      rolesMetrics.rounds[rolesMetrics.rounds.length - 2].name != stage
    ) {
      try {
        const currentRound =
          rolesMetrics?.rounds[parseInt(stageIndex) + 1]?.name || 'next round'
        const prevRound =
          rolesMetrics?.rounds[parseInt(stageIndex)]?.name || 'previous round'

        // Get company name from jobRolePreviewData
        const companyName =
          jobRolePreviewData?.company?.companyName ??
          jobRolePreviewData?.corporate?.name ??
          'the company'

        // Check if we have successful candidates from the API response
        const successCandidates = result?.data?.data?.successCandidate || []

        // Process each successful candidate
        if (successCandidates.length > 0) {
          // Arrays to hold notification payloads
          const emailPayloads = []
          const whatsappPayloads = []
          const inAppNotifications = []

          // Process each candidate
          successCandidates.forEach(candidate => {
            // Get student data from API response
            const studentId = candidate.id
            const studentName = candidate.name
            const studentEmail = candidate.primaryEmail
            const studentPhone = candidate.phoneNumber

            // Prepare data for email template
            const emailData = {
              studentName,
              companyName: companyName,
              roundName: currentRound,
              prevRoundName: prevRound,
              roleName:
                jobRolePreviewData?.tittle ||
                rolesMetrics?.tittle ||
                'the role',
              signatureName: userData?.first_name + ' ' + userData?.last_name,
              signatureRole: getUserRoleName(),
              signatureInstitute: institute?.campusName || 'Institute',
              signatureContact:
                userData?.phone_number || institute?.contactNumber,
            }

            // Render the email template for this candidate
            const emailTemplate = ReactDOMServer.renderToString(
              <ShortlistedTemplate data={emailData} />
            )

            // Add to email payloads
            emailPayloads.push({
              to: studentEmail, // Use actual student email
              subject: `Moved to Next Round`,
              htmlBody: emailTemplate,
            })

            // Add to in-app notifications
            inAppNotifications.push({
              ids: [studentId],
              userIds: [],
              roles: ['Student'],
              issuer: 'institute',
              createFor: 'student',
              inApp: true,
              body: `Congratulations! You've Been Selected\n${studentName} has been selected for ${
                jobRolePreviewData?.tittle || rolesMetrics?.tittle || 'the role'
              } at ${companyName}.`,
              tag: 'Role',
              actions: [
                {
                  name: 'View',
                  deep_link: `roles/viewrole/${
                    jobRolePreviewData?.company?.id ||
                    rolesMetrics?.company?.id ||
                    'companyId'
                  }/${roleId}`,
                  route: `roles/viewrole/${
                    jobRolePreviewData?.company?.id ||
                    rolesMetrics?.company?.id ||
                    'companyId'
                  }/${roleId}`,
                  parameters: {},
                },
              ],
            })

            // Add to WhatsApp payloads
            whatsappPayloads.push({
              to: studentPhone.replace(/\D/g, ''), // Use actual student phone
              templateName: 'tpo_application_movedtonextround',
              type: 'template',
              components: [
                {
                  type: 'BODY',
                  parameters: [
                    { type: 'TEXT', text: studentName }, // {{1}} - Student name
                    { type: 'TEXT', text: currentRound }, // {{2}} - Round name
                    {
                      type: 'TEXT',
                      text:
                        jobRolePreviewData?.tittle ||
                        rolesMetrics?.tittle ||
                        'the role',
                    }, // {{3}} - Role
                    { type: 'TEXT', text: companyName }, // {{4}} - Company name
                  ],
                },
              ],
            })
          })

          // Send email notifications
          if (emailPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmail(emailPayloads))
          }

          // Send in-app notifications
          if (inAppNotifications.length > 0) {
            const inAppObj = {
              notification: {
                students: inAppNotifications,
              },
            }
            await dispatch(sendInAppNotification(inAppObj))
          }

          // Send WhatsApp notifications
          if (whatsappPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmailWhatsapp(whatsappPayloads))
          }
        }
      } catch (error) {
        console.error('Error sending notifications:', error)
      }
    }

    // Check if status is SHORTLISTED and it is the last round
    if (
      payLoad.status === 'SHORTLISTED' &&
      rolesMetrics.rounds[rolesMetrics.rounds.length - 2].name === stage
    ) {
      try {
        const roundName =
          rolesMetrics?.rounds[parseInt(stageIndex)]?.name || 'assessment'

        // Get company name from jobRolePreviewData
        const companyName =
          jobRolePreviewData?.company?.companyName ??
          jobRolePreviewData?.corporate?.name ??
          'the company'

        // Check if we have successful candidates from the API response
        const successCandidates = result?.data?.data?.successCandidate || []

        // Process each successful candidate
        if (successCandidates.length > 0) {
          // Arrays to hold notification payloads
          const emailPayloads = []
          const whatsappPayloads = []
          const inAppNotifications = []

          // Process each candidate
          successCandidates.forEach(candidate => {
            // Get student data from API response
            const studentId = candidate.id
            const studentName = candidate.name
            const studentEmail = candidate.primaryEmail
            const studentPhone = candidate.phoneNumber

            // Prepare data for email template
            const emailData = {
              studentName,
              companyName: companyName,
              roundName: roundName,
              roleName:
                jobRolePreviewData?.tittle ||
                rolesMetrics?.tittle ||
                'the role',
              signatureName: userData?.first_name + ' ' + userData?.last_name,
              signatureRole: getUserRoleName(),
              signatureInstitute: institute?.campusName || 'Institute',
              signatureContact:
                userData?.phone_number || institute?.contactNumber,
            }

            // Render the email template for this candidate
            const emailTemplate = ReactDOMServer.renderToString(
              <IntentToOfferTemplate data={emailData} />
            )

            // Add to email payloads
            emailPayloads.push({
              to: studentEmail, // Use actual student email
              subject: `Congratulations! You've been Selected for ${
                jobRolePreviewData?.tittle || rolesMetrics?.tittle || 'the role'
              }`,
              htmlBody: emailTemplate,
            })

            // Add to in-app notifications
            inAppNotifications.push({
              ids: [studentId],
              userIds: [],
              roles: ['Student'],
              issuer: 'institute',
              createFor: 'student',
              inApp: true,
              body: `Congratulations! You've Been Selected\n${studentName} has been selected for ${
                jobRolePreviewData?.tittle || rolesMetrics?.tittle || 'the role'
              } at ${companyName}.`,
              tag: 'Role',
              actions: [
                {
                  name: 'View',
                  deep_link: `roles/viewrole/${
                    jobRolePreviewData?.company?.id ||
                    rolesMetrics?.company?.id ||
                    'companyId'
                  }/${roleId}`,
                  route: `roles/viewrole/${
                    jobRolePreviewData?.company?.id ||
                    rolesMetrics?.company?.id ||
                    'companyId'
                  }/${roleId}`,
                  parameters: {},
                },
              ],
            })

            // Add to WhatsApp payloads
            whatsappPayloads.push({
              to: studentPhone.replace(/\D/g, ''), // Use actual student phone
              templateName: 'tpo_application_intenttooffer',
              type: 'template',
              components: [
                {
                  type: 'BODY',
                  parameters: [
                    { type: 'TEXT', text: studentName }, // {{1}} - Student name
                    {
                      type: 'TEXT',
                      text:
                        jobRolePreviewData?.tittle ||
                        rolesMetrics?.tittle ||
                        'the role',
                    }, // {{2}} - Role name
                    { type: 'TEXT', text: companyName }, // {{3}} - Company name
                  ],
                },
              ],
            })
          })

          // Send email notifications
          if (emailPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmail(emailPayloads))
          }

          // Send in-app notifications
          if (inAppNotifications.length > 0) {
            const inAppObj = {
              notification: {
                students: inAppNotifications,
              },
            }
            await dispatch(sendInAppNotification(inAppObj))
          }

          // Send WhatsApp notifications
          if (whatsappPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmailWhatsapp(whatsappPayloads))
          }
        }
      } catch (error) {
        console.error('Error sending Intent to Offer notifications:', error)
      }
    }

    // Check if status is REJECTED
    if (payLoad.status === 'REJECTED') {
      try {
        const roundName =
          rolesMetrics?.rounds[parseInt(stageIndex)]?.name || 'assessment'

        // Get company name from jobRolePreviewData
        const companyName =
          jobRolePreviewData?.company?.companyName ??
          jobRolePreviewData?.corporate?.name ??
          'the company'

        // Check if we have successful candidates from the API response
        const successCandidates = result?.data?.data?.successCandidate || []

        // Process each successful candidate
        if (successCandidates.length > 0) {
          // Arrays to hold notification payloads
          const emailPayloads = []
          const whatsappPayloads = []
          const inAppNotifications = []

          // Process each candidate
          successCandidates.forEach(candidate => {
            // Get student data from API response
            const studentId = candidate.id
            const studentName = candidate.name
            const studentEmail = candidate.primaryEmail
            const studentPhone = candidate.phoneNumber

            // Prepare data for email template
            const emailData = {
              studentName,
              companyName: companyName,
              roundName: roundName,
              roleName:
                jobRolePreviewData?.tittle ||
                rolesMetrics?.tittle ||
                'the role',
              signatureName: userData?.first_name + ' ' + userData?.last_name,
              signatureRole: getUserRoleName(),
              signatureInstitute: institute?.campusName || 'Institute',
              signatureContact:
                userData?.phone_number || institute?.contactNumber,
            }

            // Render the email template for this candidate
            const emailTemplate = ReactDOMServer.renderToString(
              <RejectedTemplate data={emailData} />
            )

            // Add to email payloads
            emailPayloads.push({
              to: studentEmail, // Use actual student email
              subject: `Update: ${roundName} Status`,
              htmlBody: emailTemplate,
            })

            // Add to in-app notifications
            inAppNotifications.push({
              ids: [studentId],
              userIds: [],
              roles: ['Student'],
              issuer: 'institute',
              createFor: 'student',
              inApp: true,
              body: `You have not been selected following the recent ${roundName} for ${
                jobRolePreviewData?.tittle || rolesMetrics?.tittle || 'the role'
              } at ${companyName}.`,
              tag: 'Role',
              actions: [
                {
                  name: 'View',
                  deep_link: `roles/viewrole/${
                    jobRolePreviewData?.company?.id ||
                    rolesMetrics?.company?.id ||
                    'companyId'
                  }/${roleId}`,
                  route: `roles/viewrole/${
                    jobRolePreviewData?.company?.id ||
                    rolesMetrics?.company?.id ||
                    'companyId'
                  }/${roleId}`,
                  parameters: {},
                },
              ],
            })

            // Add to WhatsApp payloads
            whatsappPayloads.push({
              to: studentPhone.replace(/\D/g, ''), // Use actual student phone
              templateName: 'tpo_application_rejection',
              type: 'template',
              components: [
                {
                  type: 'BODY',
                  parameters: [
                    { type: 'TEXT', text: studentName }, // {{1}} - Student name
                    {
                      type: 'TEXT',
                      text:
                        jobRolePreviewData?.tittle ||
                        rolesMetrics?.tittle ||
                        'the role',
                    }, // {{2}} - Role name
                    { type: 'TEXT', text: companyName }, // {{3}} - Company name
                  ],
                },
              ],
            })
          })

          // Send email notifications
          if (emailPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmail(emailPayloads))
          }

          // Send in-app notifications
          if (inAppNotifications.length > 0) {
            const inAppObj = {
              notification: {
                students: inAppNotifications,
              },
            }
            await dispatch(sendInAppNotification(inAppObj))
          }

          // Send WhatsApp notifications
          if (whatsappPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmailWhatsapp(whatsappPayloads))
          }
        }
      } catch (error) {
        console.error('Error sending rejection notifications:', error)
      }
    }
    if (payLoad.status === 'ABSENT') {
      try {
        const roundName =
          rolesMetrics?.rounds[parseInt(stageIndex)]?.name || 'assessment'

        // Get company name from jobRolePreviewData
        const companyName =
          jobRolePreviewData?.company?.companyName ??
          jobRolePreviewData?.corporate?.name ??
          'the company'

        // Check if we have successful candidates from the API response
        const successCandidates = result?.data?.data?.successCandidate || []

        // Process each successful candidate
        if (successCandidates.length > 0) {
          // Arrays to hold notification payloads
          const emailPayloads = []
          const inAppNotifications = []

          // Process each candidate
          successCandidates.forEach(candidate => {
            // Get student data from API response
            const studentId = candidate.id
            const studentName = candidate.name
            const studentEmail = candidate.primaryEmail
            const studentPhone = candidate.phoneNumber

            // Prepare data for email template
            const emailData = {
              studentName,
              companyName: companyName,
              roundName: roundName,
              roleName:
                jobRolePreviewData?.tittle ||
                rolesMetrics?.tittle ||
                'the role',
              date: new Date().toLocaleDateString('en-IN'),
              signatureName: userData?.first_name + ' ' + userData?.last_name,
              signatureRole: getUserRoleName(),
              signatureInstitute: institute?.campusName || 'Institute',
              signatureContact:
                userData?.phone_number || institute?.contactNumber,
            }

            // Render the email template for this candidate
            const emailTemplate = ReactDOMServer.renderToString(
              <AbsentTemplate data={emailData} />
            )

            // Add to email payloads
            emailPayloads.push({
              to: studentEmail, // Use actual student email
              subject: `Absence from Evaluation – ${
                jobRolePreviewData?.tittle || rolesMetrics?.tittle || 'the role'
              } at ${companyName}`,
              htmlBody: emailTemplate,
            })

            // Add to in-app notifications
            inAppNotifications.push({
              ids: [studentId],
              userIds: [],
              roles: ['Student'],
              issuer: 'institute',
              createFor: 'student',
              inApp: true,
              body: `You were marked absent for the evaluation of ${
                jobRolePreviewData?.tittle || rolesMetrics?.tittle || 'the role'
              } at ${companyName} on ${new Date().toLocaleDateString(
                'en-IN'
              )}. Contact the placement team if there was a valid reason.`,
              tag: 'Role',
              actions: [
                {
                  name: 'View',
                  deep_link: `roles/viewrole/${
                    jobRolePreviewData?.company?.id ||
                    rolesMetrics?.company?.id ||
                    'companyId'
                  }/${roleId}`,
                  route: `roles/viewrole/${
                    jobRolePreviewData?.company?.id ||
                    rolesMetrics?.company?.id ||
                    'companyId'
                  }/${roleId}`,
                  parameters: {},
                },
              ],
            })

            // Add to WhatsApp payloads
          })

          // Send email notifications
          if (emailPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmail(emailPayloads))
          }

          // Send in-app notifications
          if (inAppNotifications.length > 0) {
            const inAppObj = {
              notification: {
                students: inAppNotifications,
              },
            }
            await dispatch(sendInAppNotification(inAppObj))
          }
        }
      } catch (error) {
        console.error('Error sending rejection notifications:', error)
      }
    }

    if (payLoad.status === 'ACTIVE') {
      try {
        const roundName =
          rolesMetrics?.rounds[parseInt(stageIndex)]?.name || 'assessment'

        // Get company name from jobRolePreviewData
        const companyName =
          jobRolePreviewData?.company?.companyName ??
          jobRolePreviewData?.corporate?.name ??
          'the company'

        // Check if we have successful candidates from the API response
        const successCandidates = result?.data?.data?.successCandidate || []

        // Process each successful candidate
        if (successCandidates.length > 0) {
          // Arrays to hold notification payloads
          const emailPayloads = []
          const inAppNotifications = []

          // Process each candidate
          successCandidates.forEach(candidate => {
            // Get student data from API response
            const studentId = candidate.id
            const studentName = candidate.name
            const studentEmail = candidate.primaryEmail
            const studentPhone = candidate.phoneNumber

            // Prepare data for email template
            const emailData = {
              studentName,
              companyName: companyName,
              roleName:
                jobRolePreviewData?.tittle ||
                rolesMetrics?.tittle ||
                'the role',

              signatureName: userData?.first_name + ' ' + userData?.last_name,
              signatureRole: getUserRoleName(),
              signatureInstitute: institute?.campusName || 'Institute',
              signatureContact:
                userData?.phone_number || institute?.contactNumber,
            }

            // Render the email template for this candidate
            const emailTemplate = ReactDOMServer.renderToString(
              <MoveToNextRoundTemplate data={emailData} />
            )

            // Add to email payloads
            emailPayloads.push({
              to: studentEmail, // Use actual student email
              subject: `Moved to Evaluation Process – ${
                jobRolePreviewData?.tittle || rolesMetrics?.tittle || 'the role'
              } at ${companyName}`,
              htmlBody: emailTemplate,
            })

            // Add to in-app notifications
            inAppNotifications.push({
              ids: [studentId],
              userIds: [],
              roles: ['Student'],
              issuer: 'institute',
              createFor: 'student',
              inApp: true,
              body: `You have been moved to the evaluation process for ${
                jobRolePreviewData?.tittle || rolesMetrics?.tittle || 'the role'
              } at ${companyName}. Please wait for the schedule and further instructions.`,
              tag: 'Role',
              actions: [
                {
                  name: 'View',
                  deep_link: `roles/viewrole/${
                    jobRolePreviewData?.company?.id ||
                    rolesMetrics?.company?.id ||
                    'companyId'
                  }/${roleId}`,
                  route: `roles/viewrole/${
                    jobRolePreviewData?.company?.id ||
                    rolesMetrics?.company?.id ||
                    'companyId'
                  }/${roleId}`,
                  parameters: {},
                },
              ],
            })

            // Add to WhatsApp payloads
          })

          // Send email notifications
          if (emailPayloads.length > 0) {
            await dispatch(sendNotificationBulkEmail(emailPayloads))
          }

          // Send in-app notifications
          if (inAppNotifications.length > 0) {
            const inAppObj = {
              notification: {
                students: inAppNotifications,
              },
            }
            await dispatch(sendInAppNotification(inAppObj))
          }
        }
      } catch (error) {
        console.error('Error sending rejection notifications:', error)
      }
    }
    // Check for Offer Issued status
    if (payLoad.status === 'SELECTED' && payLoad.offerStatus === 'RELEASED') {
      try {
        // Get company name from jobRolePreviewData
        const companyName =
          jobRolePreviewData?.company?.companyName ??
          jobRolePreviewData?.corporate?.name ??
          'the company'

        // Check if we have successful candidates from the API response
        const successCandidates = result?.data?.data?.successCandidate || []

        // Process each successful candidate
        if (successCandidates.length > 0) {
          // Collect all student IDs for a single in-app notification
          const allStudentIds = successCandidates.map(candidate => candidate.id)

          // Create a single in-app notification for all students
          const inAppObj = {
            notification: {
              students: [
                {
                  ids: allStudentIds, // Include all student IDs in a single array
                  userIds: [],
                  roles: ['Student'],
                  issuer: 'institute',
                  createFor: 'student',
                  inApp: true,
                  body: `Your status has been updated to offer issued for the role of ${
                    jobRolePreviewData?.tittle ||
                    rolesMetrics?.tittle ||
                    'the role'
                  } at ${companyName}.`,
                  tag: 'Role',
                  actions: [
                    {
                      name: 'View',
                      deep_link: `roles/viewrole/${
                        jobRolePreviewData?.company?.id ||
                        rolesMetrics?.company?.id ||
                        'companyId'
                      }/${roleId}`,
                      route: `roles/viewrole/${
                        jobRolePreviewData?.company?.id ||
                        rolesMetrics?.company?.id ||
                        'companyId'
                      }/${roleId}`,
                      parameters: {},
                    },
                  ],
                },
              ],
            },
          }

          // Send in-app notification
          await dispatch(sendInAppNotification(inAppObj))
        }
      } catch (error) {
        console.error('Error sending Offer Issued notification:', error)
      }
    }

    // Check for Offer Accepted status
    if (payLoad.status === 'SELECTED' && payLoad.offerStatus === 'ACCEPTED') {
      try {
        // Get company name from jobRolePreviewData
        const companyName =
          jobRolePreviewData?.company?.companyName ??
          jobRolePreviewData?.corporate?.name ??
          'the company'

        // Check if we have successful candidates from the API response
        const successCandidates = result?.data?.data?.successCandidate || []

        // Process each successful candidate
        if (successCandidates.length > 0) {
          // Collect all student IDs for a single in-app notification
          const allStudentIds = successCandidates.map(candidate => candidate.id)

          // Create a single in-app notification for all students
          const inAppObj = {
            notification: {
              students: [
                {
                  ids: allStudentIds, // Include all student IDs in a single array
                  userIds: [],
                  roles: ['Student'],
                  issuer: 'institute',
                  createFor: 'student',
                  inApp: true,
                  body: `Your status has been updated to offer accepted for the role of ${
                    jobRolePreviewData?.tittle ||
                    rolesMetrics?.tittle ||
                    'the role'
                  } at ${companyName}.`,
                  tag: 'Role',
                  actions: [
                    {
                      name: 'View',
                      deep_link: `roles/viewrole/${
                        jobRolePreviewData?.company?.id ||
                        rolesMetrics?.company?.id ||
                        'companyId'
                      }/${roleId}`,
                      route: `roles/viewrole/${
                        jobRolePreviewData?.company?.id ||
                        rolesMetrics?.company?.id ||
                        'companyId'
                      }/${roleId}`,
                      parameters: {},
                    },
                  ],
                },
              ],
            },
          }

          // Send in-app notification
          await dispatch(sendInAppNotification(inAppObj))
        }
      } catch (error) {
        console.error('Error sending Offer Accepted notification:', error)
      }
    }

    // Check for Offer Declined status
    if (payLoad.status === 'SELECTED' && payLoad.offerStatus === 'REJECTED') {
      try {
        // Get company name from jobRolePreviewData
        const companyName =
          jobRolePreviewData?.company?.companyName ??
          jobRolePreviewData?.corporate?.name ??
          'the company'

        // Check if we have successful candidates from the API response
        const successCandidates = result?.data?.data?.successCandidate || []

        // Process each successful candidate
        if (successCandidates.length > 0) {
          // Collect all student IDs for a single in-app notification
          const allStudentIds = successCandidates.map(candidate => candidate.id)

          // Create a single in-app notification for all students
          const inAppObj = {
            notification: {
              students: [
                {
                  ids: allStudentIds, // Include all student IDs in a single array
                  userIds: [],
                  roles: ['Student'],
                  issuer: 'institute',
                  createFor: 'student',
                  inApp: true,
                  body: `Your status has been updated to offer declined for the role of ${
                    jobRolePreviewData?.tittle ||
                    rolesMetrics?.tittle ||
                    'the role'
                  } at ${companyName}.`,
                  tag: 'Role',
                  actions: [
                    {
                      name: 'View',
                      deep_link: `roles/viewrole/${
                        jobRolePreviewData?.company?.id ||
                        rolesMetrics?.company?.id ||
                        'companyId'
                      }/${roleId}`,
                      route: `roles/viewrole/${
                        jobRolePreviewData?.company?.id ||
                        rolesMetrics?.company?.id ||
                        'companyId'
                      }/${roleId}`,
                      parameters: {},
                    },
                  ],
                },
              ],
            },
          }

          // Send in-app notification
          await dispatch(sendInAppNotification(inAppObj))
        }
      } catch (error) {
        console.error('Error sending Offer Declined notification:', error)
      }
    }
  }
  const handleCloseFilter = async () => {
    setIsMenuOpen(false)
    setDummyOpen(false)
    handleScoreChange([])
    handleArrearsChange([])
    handleLocationChange([])
    handleGenderChange([])
    handleYearChange([])
    handleSkillsChange([])
    handleStatusChange([])
  }

  useEffect(() => {
    let data = candidateDeatils?.panels
    let optionData = []
    let finalData = []
    let constantData = [
      {
        label: 'View All',
        value: 'all',
      },
    ]
    if (data?.length > 0) {
      optionData = data?.map(item => ({
        label: 'Panel ' + item?.panel,
        value: item?.panel?.toString(),
      }))

      finalData = [...constantData, ...optionData]
    }

    setPanelData(finalData)
  }, [candidateDeatils])
  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

  const menuItem = (
    <MenuFlex column className="overflow-hidden-tree">
      <StyledTabFilter
        width={'38%'}
        className={'ats-filter'}
        padding={'20px'}
        border={true}
        tabPosition={'left'}
        type="card"
        items={[
          {
            label: 'Status',
            key: '1',
            children: (
              <StatusFilter
                menuOption={menuOption}
                handleStatusChange={handleStatusChange}
                checkStatus={
                  checkStatus?.length !== 0 &&
                  checkStatus?.map(item => {
                    return item.value
                  })
                }
              />
            ),
          },
          {
            label: 'Degree & Department',
            key: '2',
            children: (
              <DegreeDepartmentFilter
                state={state}
                handleDegreeChange={handleDegreeChange}
                handleDepartmentChange={handleDepartmentChange}
                handleSpecialisationChange={handleSpecialisationChange}
                handleDegreeSearch={handleDegreeSearch}
                handleDepartSearch={handleDepartSearch}
                handleSpecializationChange={handleSpecializationChange}
                handleSpecializationSearch={handleSpecializationSearch}
              />
            ),
          },
          {
            label: 'Mandatory Skills',
            key: '3',
            children: (
              <SkillsFilter
                state={state}
                handleSkillsChange={handleSkillsChange}
                checkSkills={checkSkills}
                skillsFilter={skillsFilter}
              />
            ),
          },
          {
            label: 'Year of passing',
            key: '4',
            children: (
              <YearFilter
                state={state}
                handleYearChange={handleYearChange}
                checkYear={checkYear}
                yearFilter={yearFilter}
              />
            ),
          },
          {
            label: 'Score',
            key: '5',
            children: (
              <ScoreFilter
                ref={scoreFilterRef}
                state={state}
                handleScoreChange={handleScoreChange}
                scoreEntries={scoreEntries}
                setScoreEntries={setScoreEntries}
              />
            ),
          },
          {
            label: 'Arrears',
            key: '6',
            children: (
              <ArrearsFilter
                state={state}
                handleArrearsChange={handleArrearsChange}
                checkArrears={checkArrears}
              />
            ),
          },
          {
            label: 'Preferred Location',
            key: '7',
            children: (
              <LocationFilter
                state={state}
                handleLocationChange={handleLocationChange}
                checkLocation={checkLocation}
                locationFilter={locationFilter}
              />
            ),
          },
          {
            label: 'Gender',
            key: '8',
            children: (
              <GenderFilter
                state={state}
                handleGenderChange={handleGenderChange}
                checkGender={checkGender}
                genderFilter={genderFilter}
              />
            ),
          },
        ]}
      />
      <SubmitFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            handleCloseFilter()
            setIsMenuOpen(false)
            setDummyOpen(false)
          }}
        />
        <Button.Primary
          text="Apply Filter"
          onClick={() => {
            handleFilter()
            // // Call the ScoreFilter's handleAdd function
            // if (scoreFilterRef.current) {
            //   scoreFilterRef.current.handleAdd()
            // }
            setIsMenuOpen(false)
            setDummyOpen(false)
          }}
        />
      </SubmitFlex>
    </MenuFlex>
  )

  const handleSelectAll = () => {
    setSelectAll(true)
    setWholeSelect(true)
  }

  const handleSelect = () => {
    if (selectAll) {
      setSelectedCandidateId([])
      // return
    }
    const filteredRows = candidates.result.filter(record => {
      const isOptedOut =
        record?.student?.currentCourse?.optOutStatus === 1 ||
        record?.student?.currentCourse?.optOutStatus === 4
      
      if (isOptedOut) {
        return false
      }

      const isNotReleased = record.offerStatus === 'NOT_RELEASED'
      const isActiveOrSelected =
        record.status === 'ACTIVE' || record.status === 'SELECTED'
      const isRejected = record.status === 'REJECTED'
      const isAbsent = record.status === 'ABSENT'

      const currentStage = rolesMetrics?.rounds[stageIndex]?.name

      // Handle "all_candidates" case
      if (stage === 'all_candidates') {
        return (
          (record.status === 'ACTIVE' && record.stage === null) ||
          (record.status === 'ACTIVE' && record.stage === currentStage) ||
          (record.status === 'REJECTED' && record.stage === null)
        )
      } else {
        const nextStage = rolesMetrics?.rounds[parseInt(stageIndex) + 1]?.name
        const isInNextRoundNotUpdated = 
          record.stage === nextStage && isActiveOrSelected && isNotReleased
        
        return (
          (record.stage === currentStage &&
            (isActiveOrSelected || isRejected || isAbsent) &&
            isNotReleased) ||
          isInNextRoundNotUpdated ||
          (currentStage === 'offer' &&
            isNotReleased &&
            (isActiveOrSelected || isRejected))
        )
      }
    })
    const filteredRowKeys = filteredRows.map(item => item.studentId)
    setSelectedCandidateId(filteredRowKeys)
    setSelectedCandidate(filteredRows)
  }

  const handleClearAll = () => {
    setSelectedCandidateId([])
    setSelectedCandidate([])
    setSelectAll(false)
    setWholeSelect(false)
  }

  useEffect(() => {
    if (selectAll && !load && wholeSelect) {
      handleSelect()
    }
  }, [selectAll, load])

  useEffect(() => {
    setDummyOpen(!isMenuOpen)
  }, [isMenuOpen])
  const handleDownload = async () => {
    if (selectedCandidateId.length <= 10 && !selectAll) {
      setPopup(true)
    } else {
      setBulkDownload(true)
    }
  }
  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent:
            status == 'SCHEDULED,TO_BE_SCHEDULED' ||
            status == 'RESCHEDULED,RESCHEDULE'
              ? 'flex-end'
              : 'space-between',
          height: '4em',
          marginLeft: '2em',
        }}
      >
        {publishedBy === 'CORPORATE' ? (
          <IconContainer>
            <EmptyDivElement
              onClick={() => {
                if (selectedCandidateId?.length > 0) handleDownload()
              }}
              style={{
                cursor: selectedCandidateId?.length === 0 ? 'not-allowed' : 'pointer',
                opacity: selectedCandidateId?.length === 0 ? '0.5' : '',
              }}
            >
              <ResumeDownload />
            </EmptyDivElement>
          </IconContainer>
        ) : (
          <>
            {stage === 'all_candidates' && (
              <SimpleStatusIcon
                status={status}
                onChange={onChangeStatus}
                candidateStatus={selectedCandidate?.map(item => item.status)}
                selectedCandidateId={selectedCandidateId}
                jobRolePreviewData={jobRolePreviewData}
                rolesMetrics={rolesMetrics}
              />
            )}
            {status !== 'SCHEDULED,TO_BE_SCHEDULED' &&
              stage !== 'offer' &&
              stage !== 'all_candidates' && (
                <TableStatusIcon
                  status={status}
                  stage={stage}
                  onChange={onChangeStatus}
                  round={selectedRoundType?.type}
                  candidateStatus={selectedCandidate?.map(item => item.status)}
                  selectedCandidateId={selectedCandidateId}
                  handleDownload={handleDownload}
                />
              )}
            {stage === 'offer' && (
              <OfferTableStatusIcon
                onChange={onChangeStatus}
                status={status}
                candidateStatus={selectedCandidate?.map(item => item.offerStatus)}
                selectedCandidateId={selectedCandidateId}
                handleDownload={handleDownload}
              />
            )}
          </>
        )}

        <SelectStatusFlex>
          {panelData !== '' && panelData?.length > 0 && stage !== 'offer' && (
            <StyledSelect
              showSearch
              placeholder="Select a panel"
              optionFilterProp="children"
              filterOption={filterOption}
              options={panelData || []}
              key={panelValue}
              height="38px !important"
              width="150px"
              value={panelValue}
              valueParam="value"
              nameParam="label"
              onChange={(value, Option) => {
                setPanelValue(value)
              }}
              id="panel"
              style={{
                width: '7em',
                height: '2.6em',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '5px',
              }}
            />
          )}
          {(status == 'SCHEDULED,TO_BE_SCHEDULED' ||
            status == 'RESCHEDULED,RESCHEDULE') && (
            <Button.Secondary
              text={
                status == 'SCHEDULED,TO_BE_SCHEDULED'
                  ? 'Schedule'
                  : 'Re-Schedule'
              }
              height={'38px'}
              onClick={() => {
                setScheduleDrawer(true)
              }}
              disabled={rowSelection?.selectedRowKeys <= 0}
            />
          )}
          {stage !== 'offer' && collapseExtend?.subTopic?.length > 0 && (
            <Button.Primary
              text={expand ? 'Expand Score' : 'Collapse Score'}
              height={'38px'}
              onClick={() => {
                setExpand(!expand)
              }}
            />
          )}
          {stage !== 'all_candidates' && publishedBy === 'INSTITUTE' && (
            <Button.Danger
              wordBreak
              text={'Resolve Conflicts'}
              onClick={() => handleResolveConflict()}
              disable={conflictData?.result?.length === 0}
            />
          )}
        </SelectStatusFlex>
      </div>
      {(selectedCandidateId?.length !== 0 || selectAll) &&
        wholeSelect &&
        candidates?.totalPage > 1 &&
        (candidates?.selectableCount > 0 || candidates?.count > 0) &&
        !load && (
          <SelectAllFlex>
            <div style={{ fontSize: '13px', padding: '0px 20px' }}>
              {`Selected `}
              <span style={{ fontWeight: 800 }}>
                {(() => {
                  if (selectAll) {
                    const optedOutCount = candidates?.result?.filter(
                      record =>
                        record?.student?.currentCourse?.optOutStatus === 1 ||
                        record?.student?.currentCourse?.optOutStatus === 4
                    ).length || 0
                    
                    const totalCount = candidates?.count || 0
                    const actualCount = totalCount - optedOutCount
                    return `${actualCount} ${actualCount > 1 ? 'students' : 'student'}`
                  } else {
                    return `${selectedCandidateId?.length} ${selectedCandidateId?.length > 1 ? 'students' : 'student'}`
                  }
                })()}
              </span>
              {selectAll ? ` from all pages` : ` from this page.`}
            </div>
            <Button.Primary
              onClick={() => (selectAll ? handleClearAll() : handleSelectAll())}
              text={
                selectAll ? (
                  'Clear Selection'
                ) : (
                  <>
                    {`Select all `}
                    <span style={{ fontWeight: 800 }}>
                      {(() => {
                        const count = candidates?.count || 0;
                        return `${count} ${count > 1 ? 'students' : 'student'}`;
                      })()}
                    </span>
                    {` from all pages.`}
                  </>
                )
              }
              fontsize={'0.8rem'}
            />
          </SelectAllFlex>
        )}

      <TableSearchFilter
        placeholder="Search by name"
        handleSearch={handleFilterSearch}
        searchValue={searchBy}
        menu={menuItem}
        open={isMenuOpen}
        setOpen={setIsMenuOpen}
        onOpenChange={() => setIsMenuOpen(!isMenuOpen)}
        currentCount={candidates?.result?.length}
        totalCount={candidates?.count}
      />
      {multiSelect.length !== 0 && (
        <MultiPadding style={{ marginLeft: '10px' }}>
          <BoldText>Filter</BoldText>
          <MultiFilter
            jobRoleForm={
              multiSelect.length !== 0 &&
              multiSelect?.map(item => {
                return item.nameValue
              })
            }
            option={false}
            handleChange={handleMultiFilter}
          />
        </MultiPadding>
      )}
      <StyledTableSqare
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        rowKey={record => record?.studentId}
        columns={columns}
        dataSource={candidates?.result}
        pagination={false}
        loading={load}
        onChange={onSorting}
        scroll={{
          x: columns?.length * 100 + 150,
        }}
        className={'drivetable-table'}
        bordered
        locale={{
          emptyText: (
            <EmptyWrapper column alignCenter isSpin={load}>
              <Empty
                image={NoInterview}
                imageStyle={{ height: 300 }}
                description={
                  <SpanDescription>No data available</SpanDescription>
                }
              />
            </EmptyWrapper>
          ),
        }}
      />

      <Pagination
        onChange={pagNum => {
          onPageChange(pagNum)
          if (!selectAll) {
            handleClearAll()
          }
        }}
        totalPages={candidates?.totalPage * 10}
        pageSize={10}
        current={candidates?.page + 1}
      />

      <PlacementHistoryWithResume
        studentId={studentId}
        isOpenHistory={isOpenHistory}
        setIsOpenHistory={setIsOpenHistory}
        getJobRolePreview={getJobRolePreview}
        getStudentPlacedList={getStudentPlacedList}
        getPlacementHistoryList={getPlacementHistoryList}
        getPreview={getPreview}
        roleID={params?.roleId}
      />
    </Fragment>
  )
}

export default IndividualDriveTable
